import {Edit} from '@mui/icons-material';
import {Button, Stack} from '@mui/material';
import {StudyStatus} from '@cp/model';
import StatusChangerChip from '../../components/StatusChangerChip/StatusChangerChip';

export interface StudyPageAdminProps {
  isAdmin: boolean;
  showAdminControls: boolean;
  studyStatus?: StudyStatus;
  onStatusChange?: (status: StudyStatus) => Promise<void>;
  statusUpdating?: boolean;
  onEdit?: () => void;
  onMarkAsDone?: () => void;
  currentStudyProgressDone?: boolean;
  progressUpdating?: boolean;
}

export default function StudyPageAdmin({
  isAdmin,
  showAdminControls,
  studyStatus,
  onStatusChange,
  statusUpdating,
  onEdit,
  onMarkAsDone,
  currentStudyProgressDone,
  progressUpdating,
}: StudyPageAdminProps) {
  if (!showAdminControls) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} sx={{mb: 2}} data-testid="study-page-admin">
      {isAdmin && onStatusChange && (
        <>
          <StatusChangerChip status={studyStatus} onStatusChange={onStatusChange} disabled={statusUpdating} />
          {onEdit && (
            <Button
              startIcon={<Edit />}
              onClick={onEdit}
              variant="outlined"
              size="small"
              data-testid="study-page-edit-button"
            >
              Edit
            </Button>
          )}
        </>
      )}
      {onMarkAsDone && (
        <Button
          onClick={onMarkAsDone}
          variant={currentStudyProgressDone ? 'contained' : 'outlined'}
          size="small"
          disabled={progressUpdating}
          data-testid="study-page-mark-as-done-button"
        >
          {currentStudyProgressDone ? 'Mark as Undone' : 'Mark as Done'}
        </Button>
      )}
    </Stack>
  );
}
